import classNames from 'classnames';
import React from 'react';
import RichText from '@/components/atoms/rich-text/rich-text';
import styles from './content-search-banner.module.scss';

export interface ContentSearchBannerProps {
  /** The class name to apply */
  className?: string;
  /** The rich text to show as content */
  text?: string;
}

const ContentSearchBanner = ({ className, text }: ContentSearchBannerProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      {text && <RichText className={styles.text} text={text} />}
    </div>
  );
};

ContentSearchBanner.displayName = 'ContentSearchBanner';

export default ContentSearchBanner;
